"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toVideoHeroSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toVideoHeroSlice = function (data, logger) {
    var _a, _b, _c, _d;
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.VideoHero)), { title: logger.required(fields_1.toText((_a = data.primary) === null || _a === void 0 ? void 0 : _a.title)), description: logger.required(fields_1.toText((_b = data.primary) === null || _b === void 0 ? void 0 : _b.description)), video: logger.required(fields_1.toWebLink((_c = data.primary) === null || _c === void 0 ? void 0 : _c.video, logger)), videoType: logger.toConstValue((_d = data.primary) === null || _d === void 0 ? void 0 : _d.videoType, {
            Youtube: types_1.VideoType.Youtube,
            Libcast: types_1.VideoType.Libcast
        }), cta: field_groups_1.toCta(data.primary, logger), ctaTranscription: field_groups_1.toCta(utils_1.unprefix('transcription', data.primary), logger) }));
};
exports.toVideoHeroSlice = toVideoHeroSlice;
//# sourceMappingURL=video-hero-slice.js.map